import { z } from "zod";

/** The vendors Pax serves model calls for, each at a base URL shaped like the vendor's own. */
export const aiVendors = ["alibaba", "anthropic", "openai", "openrouter", "vertex"] as const;
export type AiVendor = (typeof aiVendors)[number];
export const AiVendor = z.enum(aiVendors).meta({
  id: "AiVendor",
  description: "A vendor whose API Pax serves model calls in.",
  example: "anthropic",
});

/** Where a vendor's API is served, so its SDK's base URL is this path on the API's origin. */
export function aiVendorBasePath(vendor: AiVendor): string {
  return `/api/ai/${vendor}/v1alpha1`;
}
